import api from '@/api'
const SET_PERMISSIONS = 'SET_PERMISSIONS'
const PERM_KEY = 'perm'

const restore = () => {
  const value = sessionStorage.getItem(PERM_KEY)
  return value ? JSON.parse(value) : null
}

export default {
  namespaced: true,

  state () {
    return {
      perm: restore()
    }
  },

  getters: {
    hasPermission: (state, getters, rootState, rootGetters) => (key, action, module = 'profeed') => {
      if (!rootGetters['account/isAdmin']) {
        return state.perm &&
          state.perm[module] &&
          state.perm[module][key] &&
          state.perm[module][key][action]
      }
      return true
    }
  },

  mutations: {
    [SET_PERMISSIONS] (state, value) {
      if (value) {
        const perm = {}
        for (const item of value) {
          if (!perm[item.module]) {
            perm[item.module] = {}
          }
          if (!perm[item.module][item.name]) {
            perm[item.module][item.name] = {}
          }
          perm[item.module][item.name].view = item.view
          perm[item.module][item.name].add = item.add
          perm[item.module][item.name].change = item.change
          perm[item.module][item.name].delete = item.delete
        }
        state.perm = perm
        sessionStorage.setItem(PERM_KEY, JSON.stringify(perm))
      } else {
        state.perm = value
      }
    }
  },

  actions: {
    async loadPermissions ({ commit, state, rootState, rootGetters }) {
      if (rootGetters['account/isStaff']) {
        let permissionsStaff = [
          {
            'id': 33,
            'module': 'animalfeed',
            'label': 'animalfeed_schedule',
            'name': 'load',
            'view': true,
            'add': true,
            'change': true,
            'delete': true
          },
          {
            'id': 32,
            'module': 'animalfeed',
            'label': 'animalfeed_schedule',
            'name': 'schedule',
            'view': true,
            'add': true,
            'change': true,
            'delete': true
          },
          {
            'id': 29,
            'module': 'profeed',
            'label': 'history',
            'name': 'history',
            'view': true,
            'add': false,
            'change': false,
            'delete': false
          },
          {
            'id': 9,
            'module': 'profeed',
            'label': 'manager',
            'name': 'animalfeed_delivery',
            'view': true,
            'add': true,
            'change': true,
            'delete': true
          },
          {
            'id': 10,
            'module': 'profeed',
            'label': 'manager',
            'name': 'animalfeed_recipe',
            'view': true,
            'add': true,
            'change': true,
            'delete': true
          },
          {
            'id': 11,
            'module': 'profeed',
            'label': 'manager',
            'name': 'animaltype',
            'view': true,
            'add': true,
            'change': true,
            'delete': true
          },
          {
            'id': 12,
            'module': 'profeed',
            'label': 'manager',
            'name': 'delivery',
            'view': true,
            'add': true,
            'change': true,
            'delete': true
          },
          {
            'id': 34,
            'module': 'profeed',
            'label': 'manager',
            'name': 'delivery_company',
            'view': true,
            'add': true,
            'change': true,
            'delete': true
          },
          {
            'id': 14,
            'module': 'profeed',
            'label': 'manager',
            'name': 'group',
            'view': true,
            'add': true,
            'change': true,
            'delete': true
          },
          {
            'id': 15,
            'module': 'profeed',
            'label': 'manager',
            'name': 'ingredient',
            'view': true,
            'add': true,
            'change': true,
            'delete': true
          },
          {
            'id': 16,
            'module': 'profeed',
            'label': 'manager',
            'name': 'loading',
            'view': true,
            'add': true,
            'change': true,
            'delete': true
          },
          {
            'id': 17,
            'module': 'profeed',
            'label': 'manager',
            'name': 'mixer',
            'view': true,
            'add': true,
            'change': true,
            'delete': true
          },
          {
            'id': 18,
            'module': 'profeed',
            'label': 'manager',
            'name': 'ration',
            'view': true,
            'add': true,
            'change': true,
            'delete': true
          },
          {
            'id': 23,
            'module': 'profeed',
            'label': 'manager',
            'name': 'stock',
            'view': true,
            'add': false,
            'change': false,
            'delete': false
          },
          {
            'id': 31,
            'module': 'profeed',
            'label': 'report',
            'name': 'additional',
            'view': true,
            'add': true,
            'change': true,
            'delete': true
          },
          {
            'id': 24,
            'module': 'profeed',
            'label': 'report',
            'name': 'dashboard',
            'view': true,
            'add': false,
            'change': false,
            'delete': false
          },
          {
            'id': 28,
            'module': 'profeed',
            'label': 'report',
            'name': 'inout',
            'view': true,
            'add': false,
            'change': false,
            'delete': false
          },
          {
            'id': 26,
            'module': 'profeed',
            'label': 'report',
            'name': 'load',
            'view': true,
            'add': false,
            'change': false,
            'delete': false
          },
          {
            'id': 25,
            'module': 'profeed',
            'label': 'report',
            'name': 'planfeed',
            'view': true,
            'add': false,
            'change': false,
            'delete': false
          },
          {
            'id': 27,
            'module': 'profeed',
            'label': 'report',
            'name': 'upload',
            'view': true,
            'add': false,
            'change': false,
            'delete': false
          },
          {
            'id': 21,
            'module': 'profeed',
            'label': 'schedule',
            'name': 'load_schedule',
            'view': false,
            'add': true,
            'change': false,
            'delete': false
          },
          {
            'id': 20,
            'module': 'profeed',
            'label': 'schedule',
            'name': 'schedule',
            'view': true,
            'add': true,
            'change': true,
            'delete': true
          },
          {
            'id': 2,
            'module': 'profeed',
            'label': 'schedule',
            'name': 'schedule_loading',
            'view': true,
            'add': false,
            'change': true,
            'delete': false
          },
          {
            'id': 22,
            'module': 'profeed',
            'label': 'schedule',
            'name': 'upload_schedule',
            'view': false,
            'add': true,
            'change': false,
            'delete': false
          }
        ]
        commit(SET_PERMISSIONS, permissionsStaff)
      }

      if (rootGetters['account/isConsultant'] && !state.perm) {
        const result = await api.dashboard.perm.permissions()
        if (result && !result.error && result.data) {
          commit(SET_PERMISSIONS, result.data.permissions)
        }
      } else if (!state.perm) {
        const result = await api.permissions.load()
        if (result && !result.error) {
          commit(SET_PERMISSIONS, result.permissions || (result.data && result.data.permissions))
        }
      }
    },

    clear ({ commit }) {
      commit(SET_PERMISSIONS, null)
      sessionStorage.removeItem(PERM_KEY)
    }
  }
}
